export default __webpack_public_path__ + "static/media/resumevid2.60c10956.gif";